import React from 'react';
import { SystemDashboardLayout} from 'library';
import HeaderDashboard from 'Components/DashboardComponent/headerdashboard/HeaderDashboard';
import { SystemGridAndForm } from 'library/form/SystemGridForm';
import ChartColor from 'Components/ChartColor/ChartColor';
import AddChartColor from 'Components/ChartColor/AddChartColor';


const ChartColorDashboard = () => {
    return (<>
        <div className="DashboardWrapperChild">           
            <div className="contentWrapper">
                <HeaderDashboard title="Top" tagLine="" />
                <div className="container-fluid mt-80">
                    <div className="row">                       
                        <div className="col-md-12">                         
                            <SystemDashboardLayout>
                                <SystemGridAndForm label="Chart Color" form={AddChartColor} grid={ChartColor} securityObject="Top.ChartColors" />
                            </SystemDashboardLayout>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </>)
}

export default ChartColorDashboard;